import { useEffect, useState, useContext, useRef } from 'react';
import axiosConn from '../../axiosConn';
import { Link, useParams, useLocation } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import validator from 'validator';
import zxcvbn from 'zxcvbn';
import './register.css';
import { useHistory } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import Footer from '../../components/footer/Footer';
import { PrivacyLink } from '../../components/footer/FooterStyles';
import SpotifyIframeNormalBlack from '../../utils/spotifyIframe';
import { ViewPortContext } from '../../context/ViewPortContext';
import fromToImg from '../../utils/fromToImg';
import { useTheme } from '../../context/ThemeContext';
import GenericHelmet from '../../components/genericHelmet/GenericHelmet'; // import your generic helmet
import TrafficConstellationsCanvas from '../../components/traffic/TrafficConstellationsCanvas';
import { AuthContext } from '../../context/AuthContext';
import { socket, getLatencyMs } from '../../context/socket';

export default function Register() {
  const { token } = useParams();
  const { height } = useContext(ViewPortContext);
  const [loading, setLoading] = useState(true);
  const { darkTheme } = useTheme();
  const { player: authedPlayer } = useContext(AuthContext);
  const location = useLocation();

  const playerInfo = {
    playerId: '',
    emailAddress: '',
    referringEmailAddress: '',
    phoneNumber: '',
    password: '',
    passwordConfirm: '',
    bYear: new Date().getFullYear(),
    bMonth: new Date().getMonth() + 1,
    bDay: new Date().getDate(),
    gender: '',
  };
  const [player, setPlayer] = useState(playerInfo);
  const [gotreferringEmailAddress, SetGotReferringEmailAddress] =
    useState('joe@joegalaxy.com');
  const {
    playerId,
    emailAddress,
    referringEmailAddress,
    phoneNumber,
    password,
    bYear,
    bMonth,
    bDay,
    gender,
  } = player;

  const history = useHistory();
  const [error, setError] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const yearTemp = new Date().getFullYear();
  const [hasDateChanged, setHasDateChanged] = useState(false);
  const from = localStorage.getItem('from');
  const queryParams = new URLSearchParams(location.search || '');
  const intentParam = queryParams.get('intent');
  const fromParam = queryParams.get('from');
  const showPresencePreface = intentParam === 'presence-demo';
  const shouldRouteToPresence =
    intentParam === 'presence-demo' ||
    (fromParam && fromParam.includes('presence-demo'));
  const loginHref = showPresencePreface ? '/login?intent=presence-demo' : '/login';
  const [showPassword, setShowPassword] = useState(false); // toggle for password visibility

  useEffect(() => {
    getReferringEmailAddress();
  }, []);

  useEffect(() => {
    // If already authenticated, skip guest wiring
    if (authedPlayer?.token) return undefined;

    let heartbeatId = null;
    let recovering = false;

    const params = new URLSearchParams(window.location.search);
    const pickParam = (key) => params.get(key) || null;
    const locale = navigator.language || '';
    const localeRegion =
      (locale.includes('-') && locale.split('-')[1]) ||
      (locale.includes('_') && locale.split('_')[1]) ||
      null;

    const guestAuth = {
      guest: 'true',
      utm_source: pickParam('utm_source'),
      utm_medium: pickParam('utm_medium'),
      utm_campaign: pickParam('utm_campaign'),
      utm_content: pickParam('utm_content'),
      region: pickParam('region') || localeRegion,
      referrer: document.referrer || null, // avoid self-URL fallback to reduce self-attribution
    };

    Object.keys(guestAuth).forEach((k) => {
      if (guestAuth[k] === null || guestAuth[k] === '') delete guestAuth[k];
    });

    // Persist attribution so reconnects and post-login sessions carry source data.
    const attribForStorage = { ...guestAuth };
    delete attribForStorage.guest;
    try {
      localStorage.setItem('jg_guest_attrib', JSON.stringify(attribForStorage));
    } catch (e) {
      // ignore storage errors
    }

    // Force guest mode: strip any lingering auth/token before connecting
    if (socket.auth) {
      delete socket.auth.token;
    } else {
      socket.auth = {};
    }
    const prevAuth = socket.auth || {};
    socket.auth = { ...prevAuth, ...guestAuth };
    if (!socket.connected) socket.connect();

    const emitHeartbeat = (activityType = 'active') => {
      const sid = socket.id;
      if (!sid || !socket.connected) return;
      const latencyMs = getLatencyMs?.();
      socket.emit('presence:heartbeat', {
        guest: true,
        sessionId: sid,
        activityType,
        latencyMs: Number.isFinite(latencyMs) ? Math.round(latencyMs) : null,
        ...geoPatchRef.current,
      });
    };

    const startHeartbeat = () => {
      if (heartbeatId) return;
      heartbeatId = setInterval(() => {
        if (socket.connected) {
          const vis =
            document.visibilityState === 'visible' ? 'active' : 'background';
          emitHeartbeat(vis);
        }
      }, 10_000);
      const vis =
        document.visibilityState === 'visible' ? 'active' : 'background';
      emitHeartbeat(vis);
    };

    const stopHeartbeat = () => {
      if (heartbeatId) {
        clearInterval(heartbeatId);
        heartbeatId = null;
      }
    };

    const handleVisibility = () => {
      const vis =
        document.visibilityState === 'visible' ? 'active' : 'background';
      emitHeartbeat(vis);
    };
    const handleFocus = () => emitHeartbeat('active');
    const handleBlur = () => emitHeartbeat('background');
    const handleConnect = () => startHeartbeat();
    const handleDisconnect = () => stopHeartbeat();
    const handleClose = () => stopHeartbeat();
    const handleGuestError = (err) => {
      if (err?.message && err.message.includes('unknown session')) {
        stopHeartbeat();
        if (recovering) return;
        recovering = true;
        socket.disconnect();
        setTimeout(() => {
          socket.connect();
          recovering = false;
        }, 200);
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    window.addEventListener('beforeunload', stopHeartbeat);
    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);
    socket.on('guest:error', handleGuestError);
    socket.on('close', handleClose);

    handleVisibility(); // initial send
    if (socket.connected) startHeartbeat();

    const requestGeoIfGranted = () => {
      if (!navigator?.permissions || !navigator?.geolocation) return;
      navigator.permissions
        .query({ name: 'geolocation' })
        .then((status) => {
          if (status.state !== 'granted') return;
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              const { latitude, longitude, accuracy } = pos.coords || {};
              if (
                typeof latitude === 'number' &&
                typeof longitude === 'number'
              ) {
                geoPatchRef.current = {
                  geo_lat: Number(latitude.toFixed(6)),
                  geo_lon: Number(longitude.toFixed(6)),
                  geo_accuracy: Math.round(accuracy || 0),
                };
                emitHeartbeat(
                  document.visibilityState === 'visible'
                    ? 'active'
                    : 'background',
                );
              }
            },
            () => {},
            {
              enableHighAccuracy: false,
              timeout: 4000,
              maximumAge: 60000,
            },
          );
        })
        .catch(() => {});
    };

    requestGeoIfGranted();

    return () => {
      stopHeartbeat();
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('beforeunload', stopHeartbeat);
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
      socket.off('guest:error', handleGuestError);
      socket.off('close', handleClose);
      if (!socket.auth?.token) socket.auth = {};
    };
  }, [authedPlayer?.token]);

  const getReferringEmailAddress = async () => {
    setPlayer({ ...player, referringEmailAddress: 'joe@joegalaxy.com' });

    try {
      setLoading(true);

      if (token.length === 5) {
        const res = await axiosConn.get(
          '/invites/getReferringEmailAddress/' + token,
          {
            headers: {
              Authorization: `Bearer ${player.token}`,
            },
          },
        );
        if (res.data.data.data) {
          SetGotReferringEmailAddress(res.data.data.data);
          setPlayer({ ...player, referringEmailAddress: res.data.data.data });
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const years = Array.from(new Array(108), (val, index) => yearTemp - index);
  const months = Array.from(new Array(12), (val, index) => 1 + index);
  const getDays = () => {
    return new Date(bYear, bMonth, 0).getDate();
  };

  const days = Array.from(new Array(getDays()), (val, index) => 1 + index);

  const isOldEnough = (bDay, bMonth, bYear, minAge) => {
    const today = new Date();
    const birthDate = new Date(bYear, bMonth - 1, bDay); // JavaScript months are 0-based
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();

    if (age > minAge) {
      return true;
    } else if (age === minAge) {
      if (
        monthDifference > 0 ||
        (monthDifference === 0 && dayDifference >= 0)
      ) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (hasDateChanged) {
      if (!isOldEnough(player.bDay, player.bMonth, player.bYear, 13)) {
        setError('Must be at least 13 years old');
      } else {
        setError('');
      }
    }
    setHasDateChanged(true);
  }, [player.bDay, player.bMonth, player.bYear]);

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;

    if (name === 'bDay' || name === 'bMonth' || name === 'bYear') {
      setPlayer({ ...player, [name]: parseInt(value) });
    } else if (
      name === 'playerId' &&
      (value.length < 6 || !validator.isAlpha(value))
    ) {
      setError('PlayerId length must be at least 6 & only Alpha Characters.');
      return;
    } else if (name === 'emailAddress' && !validator.isEmail(value)) {
      setError('Please enter a valid email address');
      return;
    } else if (name === 'phoneNumber' && !validator.isMobilePhone(value)) {
      setError('Please enter a valid phone number');
      return;
    } else if (name === 'password') {
      const passwordStrength = zxcvbn(value);
      if (passwordStrength.score < 3) {
        setError('Password is too weak.');
      } else {
        setError('');
      }
      setPlayer({ ...player, [name]: value });
    } else {
      setError('');
      if (name === 'referringEmailAddress' && value === '') {
        setPlayer({ ...player, referringEmailAddress: 'joe@joegalaxy.com' });
      } else {
        setPlayer({ ...player, [name]: value });
      }
    }
  };

  const mobileView = useMediaQuery({
    query: '(max-width: 805px)',
  });
  const nestHubView = useMediaQuery({
    query: '(max-width: 1024px)',
  });
  const geoPatchRef = useRef({});

  const handleClick = async (e) => {
    e.preventDefault();
    setIsFetching(true);

    if (!validator.isAlpha(playerId)) {
      setError('Please enter alpha characters only for playerId.');
      setIsFetching(false);
      return;
    }

    if (!validator.isEmail(player.emailAddress)) {
      setError('Please enter a valid email address');
      setIsFetching(false);
      return;
    }
    if (!validator.isEmail(player.referringEmailAddress)) {
      setError('Please enter a valid referring email address');
      setIsFetching(false);
      return;
    }
    if (!validator.isMobilePhone(player.phoneNumber)) {
      setError('Please enter a valid phone number');
      setIsFetching(false);
      return;
    }

    // Check password length
    if (player.password.length < 8) {
      setError('Password must be at least 8 characters long.');
      setIsFetching(false);
      return;
    }

    const passwordStrength = zxcvbn(player.password);
    if (passwordStrength.score < 3) {
      setError('Please enter a stronger password.');
      setIsFetching(false);
      return;
    } else {
      // Internally assign password to passwordConfirm
      player.passwordConfirm = player.password;
    }

    if (!isOldEnough(player.bDay, player.bMonth, player.bYear, 13)) {
      setError('Must be at least 13 years old');
      setIsFetching(false);
      return;
    }
    if (player.gender === '') {
      setError('Please choose a gender');
      setIsFetching(false);
      return;
    }

    try {
      await axiosConn.post('/players/signup', player);
      if (shouldRouteToPresence) {
        history.push('/presence-directory');
      } else {
        history.push('/login');
      }
      setIsFetching(false);
    } catch (err) {
      // console.log(err.response);
      setError(err.response.data.message);
      setIsFetching(false);
      console.log(err);
    }
  };

  const getPasswordStrengthColor = (score) => {
    switch (score) {
      case 3:
        return 'limegreen';
      case 4:
        return 'limegreen';
      default:
        return 'inherit';
    }
  };

  const monthAbbreviations = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  return (
    <>
      <GenericHelmet
        title="Register | JOE GALAXY.NET"
        description="Create your free JOEGALAXY.NET account to join treasure hunts, chat in groups, and explore a gamified social platform for adventure and discovery."
        image="https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1664565843/Images/JOEGALAXYDopeGalaxyLogooriginal_tecmer.png"
        url="https://www.joegalaxy.net/register"
        regionName="Worldwide"
      />
      <TrafficConstellationsCanvas />
      <div
        className={`${!mobileView ? 'register' : 'registerMobile'} ${
          darkTheme ? 'blackBg dark-theme' : ''
        }`}
      >
        <div
          className={!mobileView ? 'registerWrapper' : 'registerWrapperMobile'}
        >
          <div className="registerLeft">
            <div>
              <img
                src={fromToImg(from, 'Register')}
                alt="Joe Galaxy Logo"
              ></img>
            </div>
            <span className="registerDesc">
              <p>Level Up Your Life</p>
              {/* <p className="tag">See you at the Top...</p> */}
            </span>
          </div>

          <div className="registerRight">
            <div className="logoDescMobile">
              <div>
                <img
                  src={fromToImg(from, 'Register')}
                  alt="Joe Galaxy Logo"
                ></img>
              </div>
              <span className="loginDesc">
                <p>Level Up Your Life</p>
                {/* <p className="tag">See you at the Top...</p> */}
              </span>
            </div>

            {showPresencePreface && (
              <div className="register-intent-preface">
                You&rsquo;re about to join the live presence system.
                <br />
                You&rsquo;ll create a JG Universe account, then land directly in
                the presence evaluation path.
              </div>
            )}

            <form
              className={
                darkTheme ? 'dark-theme blackBg registerBox' : 'registerBox'
              }
              onSubmit={handleClick}
              autoComplete="on"
            >
              <div className="reg_line">
                <input
                  placeholder="PlayerId (Username)"
                  required
                  name="playerId"
                  className="loginInput"
                  onChange={handleRegisterChange}
                />
              </div>
              <div className="reg_line">
                <input
                  placeholder="Email"
                  required
                  name="emailAddress"
                  className="loginInput"
                  type="email"
                  onChange={handleRegisterChange}
                  autoComplete="username"
                />
              </div>
              <div className="reg_line">
                <input
                  placeholder="Phone"
                  required
                  name="phoneNumber"
                  className="loginInput"
                  type="phone"
                  onChange={handleRegisterChange}
                />
              </div>
              <div className="reg_line">
                <input
                  placeholder="Password"
                  required
                  name="password"
                  className="loginInput"
                  type={showPassword ? 'text' : 'password'}
                  minLength="8"
                  onChange={handleRegisterChange}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="loginInput togglePasswordBtn"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#c7cedd',
                    fontSize: 12,
                    textAlign: 'right',
                    padding: 0,
                    marginTop: 4,
                    cursor: 'pointer',
                  }}
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? 'Hide password' : 'Show password'}
                </button>
                <div className="password-strength">
                  {player.password && (
                    <div>
                      <span
                        style={{
                          color: getPasswordStrengthColor(
                            zxcvbn(player.password).score,
                          ),
                        }}
                      >
                        Password strength: {zxcvbn(player.password).score}/4
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="reg_line">
              <input
                placeholder="Password Confirm"
                required
                name="passwordConfirm"
                className="loginInput"
                type="password"
                onChange={handleRegisterChange}
                autoComplete="new-password"
              />
            </div> */}
              {/* <div className="reg_line"> */}
              <input
                placeholder="Referring emailAddress"
                name="referringEmailAddress"
                className="loginInput"
                onChange={handleRegisterChange}
                disabled={
                  gotreferringEmailAddress !== 'joe@joegalaxy.com'
                    ? true
                    : false
                }
                title={gotreferringEmailAddress}
                type={
                  validator.isEmail(gotreferringEmailAddress)
                    ? 'hidden'
                    : 'email'
                }
              />
              {/* </div> */}
              <div className="reg_col">
                <div
                  className={
                    darkTheme
                      ? 'dark-theme blackBg reg_line_header'
                      : 'reg_line_header'
                  }
                >
                  Date of birth <i className="info_icon"></i>
                </div>
                <div className="reg_grid">
                  <select
                    name="bDay"
                    value={bDay}
                    onChange={handleRegisterChange}
                  >
                    {days.map((day, i) => (
                      <option value={day} key={i}>
                        {day}
                      </option>
                    ))}
                  </select>
                  <select
                    name="bMonth"
                    value={bMonth}
                    onChange={handleRegisterChange}
                  >
                    {monthAbbreviations.map((month, i) => (
                      <option value={i + 1} key={i}>
                        {month}
                      </option>
                    ))}
                  </select>
                  <select
                    name="bYear"
                    value={bYear}
                    onChange={handleRegisterChange}
                  >
                    {years.map((year, i) => (
                      <option value={year} key={i}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="reg_col">
                  <div
                    className={
                      darkTheme
                        ? 'dark-theme blackBg reg_line_header'
                        : 'reg_line_header'
                    }
                  >
                    Gender <i className="info_icon"></i>
                  </div>
                  <div className="reg_grid">
                    <label
                      className={darkTheme ? 'dark-theme blackBg reg_grid' : ''}
                      htmlFor="male"
                    >
                      Male
                      <input
                        type="radio"
                        name="gender"
                        id="male"
                        value="male"
                        onChange={handleRegisterChange}
                      />
                    </label>
                    <label
                      className={darkTheme ? 'dark-theme blackBg reg_grid' : ''}
                      htmlFor="female"
                    >
                      Female
                      <input
                        type="radio"
                        name="gender"
                        id="female"
                        value="female"
                        onChange={handleRegisterChange}
                      />
                    </label>
                  </div>
                </div>
                <div className="reg_info">
                  By clicking Sign Up, you agree to our{' '}
                  <PrivacyLink
                    href="https://www.termsfeed.com/live/3d1dff9b-43cf-411f-8bd0-d96a8df1d4d1"
                    target="_blank"
                  >
                    Terms, Privacy, & Data Policy. &nbsp;
                  </PrivacyLink>
                  You may receive SMS & Email notifications from us and can opt
                  out at any time.
                </div>
              </div>

              {error && <div className="error_text">{error}</div>}

              <button
                className="animated-subscribe-btn registerButton"
                type="submit"
                disabled={isFetching}
              >
                {isFetching ? (
                  <CircularProgress color="inherit" size="20px" />
                ) : (
                  'Sign Up'
                )}
              </button>
              <div className="registerCenter">
                <Link
                  to={loginHref}
                  style={{ textDecoration: 'none' }}
                  title="Login to Joe Galaxy"
                >
                  <button className="loginRegisterButton">
                    Log into Account
                  </button>
                </Link>
              </div>
            </form>
            {/* Subtle presence note for credibility without altering layout */}
            <div
              style={{
                fontSize: 12,
                color: darkTheme ? '#9aa5b1' : '#475467',
                textAlign: 'center',
                marginTop: 12,
              }}
            >
              {/* On mobile (no footer), link to Presence Engine landing for credibility */}
              {mobileView ? (
                <a
                  href="https://presence-sdk-landing.joegalaxy.net"
                  style={{ color: 'inherit', textDecoration: 'none' }}
                  aria-label="Powered by JG Presence Engine (live)"
                >
                  Powered by JG Presence Engine (live)
                </a>
              ) : (
                'Powered by JG Presence Engine (live)'
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Always show footer on desktop; rely on footer responsiveness for spacing */}
      {!mobileView && <Footer />}
    </>
  );
}
